import { merchantApi } from '@/config/axios'

// 获得地区树
export const getAreaTree = async () => {
  return await merchantApi.get({ url: '/merchant-api/system/area/tree' })
}
